/*
 * Module for the multiple member update pay period view
*/

rs.module("content/employer/reporting/maintenance/multiplememberupdate/payperioddetail",

    [/* Dependencies */],

    function () {

        // Global mapping of the pay period number to the pay period key.
        var _payPeriodKeyDictionary = {};

        // Global mapping of the contribution name to the available contribution key.
        var _availableContributionKeyDictionary = {};

        //
        // Initialize
        //
        function initialize(salaryGridLrsApi, contributionsGridLrsApi, spcGridLrsApi, columnIds, payPeriodKeyDictionary, availableContributionKeyDictionary) {

            // Set dictionary object(s).
            _payPeriodKeyDictionary = payPeriodKeyDictionary;
            _availableContributionKeyDictionary = availableContributionKeyDictionary;

            // Suppress hidden columns from appearing in the column's tool panel so they can't be reshown.
            suppressHiddenColumnsFromToolPanel(salaryGridLrsApi);
            suppressHiddenColumnsFromToolPanel(contributionsGridLrsApi);
            suppressHiddenColumnsFromToolPanel(spcGridLrsApi);

            // Setup salary grid change events.
            salaryGridLrsApi.rowChanged(function (change) {
                if (change.newData) {

                    // Resolve pay period key from composite pay period num + end date.
                    change.newData[columnIds.salaryDetailPayPeriodKey] = getPayPeriodKey(change.newData[columnIds.salaryDetailCompositePayPeriod]);
                }
            });

            // Setup contribution grid change events.
            contributionsGridLrsApi.rowChanged(function (change) {
                if (change.newData) {

                    // Resolve available contribution key.
                    change.newData[columnIds.contributionAvailableContributionKey] = _availableContributionKeyDictionary[change.newData[columnIds.contributionName]];

                    // Resolve pay period key from composite pay period num + end date.
                    change.newData[columnIds.contributionDetailPayPeriodKey] = getPayPeriodKey(change.newData[columnIds.contributionDetailCompositePayPeriod]);
                }
            });

            // setup spc grid change events
            spcGridLrsApi.rowChanged(function (change) {
                if (change.newData) {

                    // Resolve pay period key from composite pay period num + end date.
                    change.newData[columnIds.spcDetailPayPeriodKey] = getPayPeriodKey(change.newData[columnIds.spcDetailCompositePayPeriod]);
                }
            });

            // Since our dictionary is int/string, but we get a string from our rows, retrieve based on the string
            function getPayPeriodKey(compositePayPeriod) {
                return Object.keys(_payPeriodKeyDictionary).find(key => _payPeriodKeyDictionary[key] === compositePayPeriod);
            }

            // Suppress invisible columns from appearing in the Columns Tool Panel
            function suppressHiddenColumnsFromToolPanel(lrsGridApi) {

                // Find the column(s) that have the hidden property.
                var columns = lrsGridApi.agGridApi.getColumns().filter(function (column) { return column.colDef["hide"]; });

                // Update all columns with the new property
                columns.forEach(function (column) {
                    column.colDef["suppressColumnsToolPanel"] = true;
                });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);